<template>
    <div class="box">
        <p class="title">{{detail.title}}</p>
        <div class="content" v-html="detail.content"></div>
    </div>
</template>

<script>
import fetchData from '@/utils/fetch';
    export default {
        data() {
            return {
                id: this.$route.query.id,
                detail: {},
            }
        },
        created() {
            fetchData('getQuestionStaticDetail', { id: this.id}).then((result) => {
                this.detail = result.data;
            }).catch((err) => {
                
            });
        }
    }
</script>

<style lang="scss" scoped>
    .box {
        padding: 48px 28px;
        .title {
            margin-bottom: 30px;
            font-size: 24px;
            font-weight: bold;
        }
    }
</style>